import checkJwtToken from './checkJwtToken';
import initIntercom from './initIntercom';
import bootstrapOthers from './others';

export default () => {
   bootstrapOthers();
   initIntercom();
   checkJwtToken();
};
